import { FooterPattern, FooterLogo } from "../../../utils/allImgs";
import qr from "../../../assets/img/sjjl.png";

import "../Footer.scss";
import { useTranslation } from "react-i18next";

const FooterPages = () => {
  const { t } = useTranslation();

  return (
    <footer
      className="footer-area bg-img mt-5"
      style={{ backgroundImage: `url(${FooterPattern})` }}
      id="footer"
    >
      {/* ##### Contact Area End ##### */}
      <div
        className="footer-area bg-img"
        style={{ backgroundImage: `url(${FooterPattern})` }}
      >
        <div className="footer-content-area demo">
          <div className="container">
            <div className="row ">
              <div className="col-12 col-lg-3 col-md-6">
                <div className="footer-copywrite-info">
                  <div
                    className="copywrite_text fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div className="footer-logo">
                      <a href="#about">
                        <img draggable="false" src={FooterLogo} alt="logo" />{" "}
                      </a>
                    </div>
                    <h4>{t("footer.name")}</h4>
                    <p>{t("footer.small")}</p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-3 col-md-6">
                <div className="contact_info_area d-sm-flex justify-content-between">
                  <div
                    className="contact_info mt-s text-center fadeInUp"
                    data-wow-delay="0.3s"
                  >
                    <h5>{t("footer.addressTitle")}</h5>
                    <a href="https://www.google.com/maps/place/Itstcc/@21.5087715,39.1726939,17z/data=!3m1!4b1!4m5!3m4!1s0x15c3cf0355935771:0xf7ebc76a18e1dec4!8m2!3d21.5087715!4d39.1726939?hl=en-SA">
                      <p>{t("footer.address")}</p>
                    </a>
                  </div>
                </div>
                <div className="mt-2">
                  <iframe
                    title="address"
                    width={"90%"}
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3711.9731531080706!2d39.1726939!3d21.508771499999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3cf0355935771%3A0xf7ebc76a18e1dec4!2sItstcc!5e0!3m2!1sen!2ssa!4v1656840769313!5m2!1sen!2ssa"
                  ></iframe>
                </div>{" "}
              </div>
              <div className="col-12 col-lg-3 col-md-6">
                <div className="contact_info_area d-sm-flex justify-content-between">
                  <div
                    className="contact_info mt-s text-center fadeInUp"
                    data-wow-delay="0.3s"
                  >
                    <h5>{t("footer.callTitle")}</h5>{" "}
                    <p>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        data-reactroot=""
                      >
                        <path
                          strokeLinejoin="round"
                          strokeLinecap="round"
                          strokeMiterlimit="10"
                          strokeWidth="1"
                          stroke="#aab2d0"
                          fill="none"
                          d="M16.46 13.55L14.34 15.67L8.32999 9.66L10.45 7.54L5.90999 3L3.78999 5.12C1.83999 7.07 3.62999 12.03 7.79999 16.2C11.97 20.37 16.93 22.16 18.88 20.21L21 18.09L16.46 13.55Z"
                        ></path>
                      </svg>
                      &nbsp; +966 122280274
                    </p>{" "}
                    <p>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        data-reactroot=""
                      >
                        <path
                          strokeLinejoin="round"
                          strokeLinecap="round"
                          strokeMiterlimit="10"
                          strokeWidth="1"
                          stroke="#aab2d0"
                          fill="none"
                          d="M16.46 13.55L14.34 15.67L8.32999 9.66L10.45 7.54L5.90999 3L3.78999 5.12C1.83999 7.07 3.62999 12.03 7.79999 16.2C11.97 20.37 16.93 22.16 18.88 20.21L21 18.09L16.46 13.55Z"
                        ></path>
                      </svg>
                      &nbsp; +966 502933388
                    </p>
                    <a href="https://wa.me/966122280274">
                      <p>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          data-reactroot=""
                        >
                          <path
                            strokeLinejoin="round"
                            strokeLinecap="round"
                            strokeMiterlimit="10"
                            strokeWidth="1"
                            stroke="#aab2d0"
                            fill="none"
                            d="M19.1914 4.8C17.4623 3.07 15.0735 2 12.4448 2C9.81609 2 7.41729 3.07 5.69815 4.8C3.96902 6.53 2.89955 8.92 2.89955 11.56C2.89955 13.65 3.57921 15.59 4.71864 17.16L2 22L8.69665 20.32C9.0065 20.45 9.32634 20.58 9.64618 20.68C10.5357 20.96 11.4653 21.1 12.4448 21.1C15.0835 21.1 17.4723 20.03 19.2014 18.3C20.9305 16.57 22 14.19 22 11.56C21.99 8.92 20.9205 6.53 19.1914 4.8Z"
                          ></path>
                          <path
                            strokeLinejoin="round"
                            strokeLinecap="round"
                            strokeMiterlimit="10"
                            strokeWidth="1"
                            stroke="#aab2d0"
                            fill="none"
                            d="M9.81273 14.19C12.325 16.7 15.3877 17.72 16.6388 16.46L18 15.1L15.2676 12.37L13.9064 13.73L10.2731 10.09L11.6343 8.73L8.90192 6L7.54071 7.36C6.27959 8.62 7.3005 11.68 9.81273 14.19Z"
                          ></path>
                        </svg>
                        &nbsp; {t("footer.whats")}{" "}
                      </p>
                    </a>
                    <p className="mt-2">
                      <a href="https://www.instagram.com/itstcch/">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="#aab2d0"
                          className="bi bi-instagram"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />{" "}
                        </svg>
                      </a>
                      &nbsp;&nbsp;
                      <a className="ms-3" href="https://twitter.com/ItstccH">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          stroke="#aab2d0"
                          fill="none"
                          className="bi bi-twitter"
                          viewBox="0 0 16 16"
                        >
                          {" "}
                          <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z" />{" "}
                        </svg>
                      </a>
                      &nbsp; @itstccH
                    </p>
                  </div>
                </div>
              </div>{" "}
              <div className="col-12 col-lg-3 col-md-6">
                <div className="contact_info_area d-sm-flex justify-content-between">
                  <div
                    className="contact_info mt-s text-center fadeInUp"
                    data-wow-delay="0.3s"
                  >
                    <img alt="" src={qr} style={{ width: 120, height: 120 }} />
                    <div
                      className="contact_info text-center "
                      style={{ marginTop: 10, marginLeft: 10, fontSize: 14 }}
                    >
                      <p>© {new Date().getFullYear()}, ITSTCC</p>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterPages;
